import React, { useEffect, useMemo, useState } from 'react'
import _ from 'lodash'
import { useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults'
import { motion, animate } from 'framer-motion';
import { createInitials } from 'global/common/dataAdjust';

const MatchRealtimeScores = ({ match_true }) => {

  const _umr = useMatchResults({ match_true })
  const { rtrs } = _umr

  // const [flashKey, setFlashKey] = useState(0);

  // useEffect(() => {
  //   setFlashKey((prev) => prev + 1);
  // }, [scores]);

  const scoreLine = (rts) => {
    const { scores, setNumber, displayName } = rts ?? {}
    if (!_.isEmpty(scores)) {
      const scrd = _.map(scores, (score, sn) => {
        const _setNumber = sn.replace('set', '')
        return <div className={`rtss ${setNumber === parseInt(_setNumber) ? 'seta' : _setNumber}`}>
          <span className={score.away > score.home ? 'tsw' : ''}>{score?.away}</span>
          <span>-</span>
          <span className={score.home > score.away ? 'tsw' : ''}>{score?.home}</span>
        </div>
      })
      return <div className='match-rez-rt'>
        <div className={'mrl-c'}>{`👉 ${setNumber}`}</div>
        <div className={'mrl'}> {scrd}</div>
        <div className={'mrl-s'} >{createInitials(displayName)}</div>
      </div>
    }
  }

  const scoreLines = useMemo(() => {
    if (!rtrs) return;
    const _scoreLines = _.map(rtrs, (rts, uid) => {
      return scoreLine(rts)
    })
    return _scoreLines
  }, [rtrs])

  return scoreLines

}

export default MatchRealtimeScores